export const EXPLAIN_THE_WIZARD_FEATURE_FLAG = 'beetroots_explain_the_wizard_web_enabled'
